import React from 'react'

export default function NotFound() {
  return (
    <div className=' mt-48 container p-10 m-auto min-h-screen'>
      <h1 className='text-red-600 text-3xl   '>OOPS! </h1>
      <p className='text-xl mt-1'>Page Not Found ..</p>
      <img className='text-center m-auto mt-10' src='/no-results (1).png'/>
    </div>
  )
}
